<ion-header class=ion-no-border>
    <ion-toolbar mode="ios">
        <ion-title>{{'SpiritualGrowth' | translation}}</ion-title>
        <ion-buttons slot="end">
            <ion-button fill="clear" (click)="checkDataChange()">
                <ion-icon name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    <ion-item>
        <ion-label>{{'PresentedTheGospel' | translation}}</ion-label>
        <ion-checkbox *ngIf="preferences.discipleship" [(ngModel)]="preferences.discipleship.presented_gospel" (ngModelChange)="spirtualGrowthChnages('Presented The Gospel', $event)" slot="start"></ion-checkbox>
    </ion-item>
    <ion-item>
        <ion-label>{{'Salvation' | translation}}</ion-label>
        <ion-checkbox *ngIf="preferences.discipleship" [(ngModel)]="preferences.discipleship.salvation" (ngModelChange)="spirtualGrowthChnages('Salvation', $event)" slot="start"></ion-checkbox>
    </ion-item>
    <ion-item>
        <ion-label>{{'ConnectedOnTheGround' | translation}}</ion-label>
        <ion-checkbox *ngIf="preferences.discipleship" [(ngModel)]="preferences.discipleship.connected_on_the_ground" (ngModelChange)="spirtualGrowthChnages('Connected On The Ground', $event)" slot="start"></ion-checkbox>
    </ion-item>
    <ion-item>
        <ion-label position="stacked">{{'ChurchName' | translation}}</ion-label>
        <ion-input  *ngIf="preferences.discipleship" [(ngModel)]="preferences.discipleship.church_name" (ngModelChange)="spirtualGrowthChnages('Church Name', $event)"></ion-input>
    </ion-item>
    <ion-item>
        <ion-label>{{'Baptism' | translation}}</ion-label>
        <ion-checkbox *ngIf="preferences.discipleship" [(ngModel)]="preferences.discipleship.baptism" (ngModelChange)="spirtualGrowthChnages('Baptism', $event)" slot="start"></ion-checkbox>
    </ion-item>
    <ion-item>
        <ion-select label="{{'Share' | translation}}" label-placement="stacked" *ngIf="preferences.discipleship" [(ngModel)]="preferences.discipleship.share_growth" (ngModelChange)="spirtualGrowthChnages('Share', $event)" placeholder="{{'SelectOne' | translation}}" okText="{{'Okay' | translation}}" cancelText="{{'Cancel' | translation}}">
            <ion-select-option value="explained">{{'Explained' | translation}}</ion-select-option>
            <ion-select-option value="concerned">{{'Concerned' | translation}}</ion-select-option>
            <ion-select-option value="preparing">{{'Preparing' | translation}}</ion-select-option>
            <ion-select-option value="active">{{'Active' | translation}}</ion-select-option>
        </ion-select>
    </ion-item>
    <ion-item>
        <ion-select label="{{'HolySpirit' | translation}}" label-placement="stacked" *ngIf="preferences.discipleship" [(ngModel)]="preferences.discipleship.holy_spirit_growth" (ngModelChange)="spirtualGrowthChnages('Holy Spirit', $event)" placeholder="{{'SelectOne' | translation}}" okText="{{'Okay' | translation}}" cancelText="{{'Cancel' | translation}}">
            <ion-select-option value="explained">{{'Explained' | translation}}</ion-select-option>
            <ion-select-option value="understands">{{'Understands' | translation}}</ion-select-option>
            <ion-select-option value="filled">{{'Filled' | translation}}</ion-select-option>
            <ion-select-option value="walking">{{'Walking' | translation}}</ion-select-option>
        </ion-select>
    </ion-item>
    <ion-item>
        <ion-select label="{{'Church' | translation}}" label-placement="stacked" *ngIf="preferences.discipleship" [(ngModel)]="preferences.discipleship.church_growth" (ngModelChange)="spirtualGrowthChnages('Church', $event)" placeholder="{{'SelectOne' | translation}}" okText="{{'Okay' | translation}}" cancelText="{{'Cancel' | translation}}">
            <ion-select-option value="explained">{{'Explained' | translation}}</ion-select-option>
            <ion-select-option value="occasional">{{'Occasional' | translation}}</ion-select-option>
            <ion-select-option value="consistent">{{'Consistent' | translation}}</ion-select-option>
            <ion-select-option value="serving">{{'Serving' | translation}}</ion-select-option>
        </ion-select>
    </ion-item>
    <ion-item>
        <ion-select label="{{'Bible' | translation}}" label-placement="stacked" *ngIf="preferences.discipleship" [(ngModel)]="preferences.discipleship.bible_growth" (ngModelChange)="spirtualGrowthChnages('Bible', $event)" placeholder="{{'SelectOne' | translation}}" okText="{{'Okay' | translation}}" cancelText="{{'Cancel' | translation}}">
            <ion-select-option value="explained">{{'Explained' | translation}}</ion-select-option>
            <ion-select-option value="sometimes">{{'Sometimes' | translation}}</ion-select-option>
            <ion-select-option value="consistent">{{'Consistent' | translation}}</ion-select-option>
            <ion-select-option value="life-application">{{'LifeApplication' | translation}}
            </ion-select-option>
        </ion-select>
    </ion-item>
    <ion-item>
        <ion-select label="{{'Prayer' | translation}}" label-placement="stacked" *ngIf="preferences.discipleship" [(ngModel)]="preferences.discipleship.prayer_growth" (ngModelChange)="spirtualGrowthChnages('Prayer', $event)" placeholder="{{'SelectOne' | translation}}" okText="{{'Okay' | translation}}" cancelText="{{'Cancel' | translation}}">
            <ion-select-option value="requests">{{'Requests' | translation}}</ion-select-option>
            <ion-select-option value="self-focused">{{'SelfFocused' | translation}}</ion-select-option>
            <ion-select-option value="regularly">{{'Regularly' | translation}}</ion-select-option>
            <ion-select-option value="interceding">{{'Interceding' | translation}}</ion-select-option>
        </ion-select>
    </ion-item>

    <ion-button class="pty-save-seeker-button" expand="full" shape="round" (click)="saveProfile()">
        {{'Save' | translation}}
    </ion-button>
</ion-content>
